import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  Disclaimer,
  Div,
  DragSortIcon,
  EditPenIcon,
  H5,
  Icon,
  P,
  TrashIconRed,
  lightTheme,
} from '@vgrubs/components';
import { BTCategoryResponse } from 'components/src/types/brand.types';

export const CategoryComponent = ({
  item,
  onClick,
  onClickDelete,
}: {
  item: BTCategoryResponse;
  onClick?: (item: BTCategoryResponse) => void;
  onClickDelete?: (id: BTCategoryResponse['id']) => void;
}) => {
  const {
    setNodeRef,
    listeners,
    attributes,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: item.id,
    // disabled: disabled,
  });

  const styles = {
    transform: CSS.Translate.toString(transform),
    transition,
    zIndex: isDragging ? 1000 : 0,
    opacity: isDragging ? 0.3 : 1,
  };

  return (
    <Div
      ref={setNodeRef}
      style={styles}
      {...attributes}
      $box
      $p="12px 24px "
      $flex
      $alignCenter
      $between
      $mb="8"
      $width="100%"
    >
      <Div $flex $gap="16px">
        <Icon
          {...listeners}
          style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
        >
          <DragSortIcon />
        </Icon>

        <Div $width="100%" onClick={() => onClick?.(item)} $pointer>
          <H5 $m="0" $color={lightTheme.primary}>
            {item.name}
          </H5>
          {item.description && (
            <P $color={lightTheme.lightGray} $mb="0">
              {item.description}
            </P>
          )}
          <P $mb="0">
            {item.items.length} {item.items.length === 1 ? 'item' : 'items'}
          </P>
          <Disclaimer $mb="0" $color={lightTheme.lightGray}>
            {item.minItems ? `Minimum ${item.minItems} items` : ''}{' '}
            {item.minItems && item.maxItems ? `-` : ''}{' '}
            {item.maxItems ? `Maximum ${item.maxItems} items` : ''}
          </Disclaimer>
        </Div>
      </Div>
      <Div $flex $alignCenter $between $gap="24px" $gapSM="12px">
        <Icon $shadow $pointer onClick={() => onClick?.(item)}>
          <EditPenIcon />
        </Icon>
        <Icon $pointer onClick={() => onClickDelete?.(item.id)}>
          <TrashIconRed />
        </Icon>
      </Div>
    </Div>
  );
};
